import React from 'react';
import { motion } from 'framer-motion';

const PageWrapper = ({ children, className = "" }) => {
  // Responsive animation timing based on screen size
  const getAnimationTiming = () => {
    if (typeof window !== 'undefined') {
      const width = window.innerWidth;
      if (width < 768) {
        return { duration: 0.2, stagger: 0.03, delay: 0.05 };
      } else if (width < 1024) {
        return { duration: 0.25, stagger: 0.04, delay: 0.08 };
      } else {
        return { duration: 0.3, stagger: 0.05, delay: 0.1 };
      }
    }
    return { duration: 0.3, stagger: 0.05, delay: 0.1 };
  };

  const { duration, stagger, delay } = getAnimationTiming();

  const pageVariants = {
    initial: { 
      opacity: 0.95,
      y: 8
    },
    in: { 
      opacity: 1,
      y: 0
    },
    out: { 
      opacity: 0.95,
      y: -8
    }
  };

  const pageTransition = {
    type: "tween",
    ease: "easeOut",
    duration: duration
  };

  const containerVariants = {
    initial: { opacity: 0.98 },
    in: { 
      opacity: 1,
      transition: {
        staggerChildren: stagger,
        delayChildren: delay
      }
    }
  };

  const childVariants = {
    initial: { 
      opacity: 0.95,
      y: 4
    },
    in: { 
      opacity: 1,
      y: 0,
      transition: {
        duration: duration * 0.8,
        ease: "easeOut"
      }
    }
  };

  return (
    <motion.div
      className={className}
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <motion.div
        variants={containerVariants}
        initial="initial"
        animate="in"
      >
        {React.Children.map(children, (child, index) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              variants: childVariants,
              custom: index
            });
          }
          return child;
        })}
      </motion.div>
    </motion.div>
  );
};

export default PageWrapper;
